<template>
    <div class="calendar-day__performances">
        <a v-for="performance in uniquePerformances" v-if="performance.status == 'A'" :key="performance.id" :href="'#'+performance.pricingTierCode || null">
            {{ performance.time }}
            <span >{{ performance.pricingTierCode }}</span>
        </a>
        <div v-else style="color: #6e6b6a; font-weight: 700;">
            {{ performance.time }}
            <span><i class="fa fa-asterisk" style="color: #6e6b6a; font-size: 10px; position: relative; top: -2px;"></i></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PerformanceLinks",
        props: {
            day: Object,
            performances: Array
        },
        computed: {
            uniquePerformances() {
                return this.performances && this.performances.reduce((acc, performance) => {
                    if (!acc.some(existingPerformance => existingPerformance.foxtrotPerformanceId === performance.foxtrotPerformanceId)) {
                        acc.push(performance);
                    }
                    return acc;
                }, []);
            }
        }
    }
</script>
